/**
 * CSS Keyframe animations for the landing page
 * Used primarily for the animated survey mockups in the hero section
 * Matches the original static landing page animations exactly
 */
import { keyframes } from '@mui/material/styles';

// Progress bar animation - cycles through stages over 16 seconds
// Matches original: 0% → 25% → 50% → 75% → 100%
export const progressCycle = keyframes`
  0% { width: 0%; }
  6.25% { width: 25%; }
  25% { width: 25%; }
  31.25% { width: 50%; }
  50% { width: 50%; }
  56.25% { width: 75%; }
  75% { width: 75%; }
  81.25% { width: 100%; }
  100% { width: 100%; }
`;

// Question visibility animations - each question visible for 25% of cycle
// Question 1: visible 0-25%
export const questionCycle1 = keyframes`
  0% { opacity: 0; }
  2% { opacity: 1; }
  23% { opacity: 1; }
  25% { opacity: 0; }
  100% { opacity: 0; }
`;

// Question 2: visible 25-50%
export const questionCycle2 = keyframes`
  0% { opacity: 0; }
  25% { opacity: 0; }
  27% { opacity: 1; }
  48% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 0; }
`;

// Question 3: visible 50-75%
export const questionCycle3 = keyframes`
  0% { opacity: 0; }
  50% { opacity: 0; }
  52% { opacity: 1; }
  73% { opacity: 1; }
  75% { opacity: 0; }
  100% { opacity: 0; }
`;

// Question 4: visible 75-100%
export const questionCycle4 = keyframes`
  0% { opacity: 0; }
  75% { opacity: 0; }
  77% { opacity: 1; }
  98% { opacity: 1; }
  100% { opacity: 0; }
`;

// Survey card appearance animation
export const surveyCardAppear = keyframes`
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

// Animation duration constant (16 seconds for full cycle)
export const SURVEY_ANIMATION_DURATION = '16s';

// Animation delays for staggered mockups (negative values to offset in cycle)
// Instance 1: 0s, Instance 2: -4s, Instance 3: -8s, Instance 4: -12s
export const MOCKUP_DELAYS = ['0s', '-4s', '-8s', '-12s'] as const;
